import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { setRxdb } from '@helper/utils';
import { useCheckRxdb } from '@hooks/checkRxdb';
import { MDPMeetingObject } from '@components/meetingModule/components/mdp-meeting-card';
import { usePermissionCheckForApiCallback } from '../../../authGuard';

export const useMdpMeetingListQuery = (): IQueryResponse<Array<MDPMeetingObject>> => {
	const { isDbChecked, shouldFetch } = useCheckRxdb('mdp_meeting_list');
	const { permissionForApi } = usePermissionCheckForApiCallback({ componentName: 'Meetings' });

	const fetchMeetingListData = async (): Promise<Array<MDPMeetingObject>> => {
		const response = await APIService.getData<Array<MDPMeetingObject>>(APICONFIG.MDP_MEETINGS_DETAILS, {
			limit: '0',
		});
		if (response) {
			const data = response.map((item) => {
				return { ...item, id: item.id.toString() };
			});
			await setRxdb('mdp_meeting_list', data);
		}
		return response;
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['MdpMeetingList'],
		queryFn: fetchMeetingListData,
		enabled: permissionForApi ? isDbChecked && shouldFetch : false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
